"use client";

import { useProductsInfo } from "@/lib/products-info";
import { buildGbTiers } from "@/lib/pricing-utils";
import PricingTierGrid from "@/components/sections/products/shared/pricing-tier-grid";
import { ROUTES } from "@/lib/constants";
import { FALLBACK_RES_TIERS, PLAN_FEATURES, CARD_PLAN_NAMES, CARD_HIGHLIGHTS } from "./data";

interface Props {
  /** Show only a representative slice (entry + 2 more tiers) with a link to the full pricing
   *  page, instead of the complete ladder. Used on the product page — the pricing page owns
   *  the full price ladder. */
  compact?: boolean;
}

export default function TierGrid({ compact = false }: Props = {}) {
  const info = useProductsInfo();
  const tiers = buildGbTiers(info?.["Monthly Per GB Residential"] ?? [], FALLBACK_RES_TIERS);

  return (
    <PricingTierGrid
      tiers={tiers}
      planNames={CARD_PLAN_NAMES}
      cardHighlights={CARD_HIGHLIGHTS}
      sharedFeatures={PLAN_FEATURES}
      enterpriseTitle="Need more than 10 TB?"
      enterpriseDescription="Custom rotation rules, priority support, higher volume limits, and pricing starting at $0.5/GB."
      {...(compact
        ? {
            maxCards: 3,
            moreLink: {
              label: "View all residential proxy plans",
              href: ROUTES.pricingResidentialProxies,
            },
          }
        : {})}
    />
  );
}
